export default __webpack_public_path__ + "static/media/Type-D.c79fa80b.jpg";